import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { ListagemProdutoComponent } from '../../views/relatorio/listagem-produto/listagem-produto.component';

@Injectable({
  providedIn: 'root'
})
export class ListagemContasReceberPagarService {

  readonly url = `${environment.apiURL}/relatorio/listagem_contas_receber_pagar`;

  constructor(private http: HttpClient) { }

  saveOrUpdate(relatorio: ListagemProdutoComponent): Observable<ListagemProdutoComponent> {
    return this.http.put<ListagemProdutoComponent>(`${this.url}`, relatorio);
  }

  getItem(id: number ): Observable<ListagemProdutoComponent> {
    return this.http.get<ListagemProdutoComponent>(`${this.url}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<ListagemProdutoComponent>> {
    return this.http.get<PageResult<ListagemProdutoComponent>>(`${this.url}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<ListagemProdutoComponent>> {
    return this.http.get<PageResult<ListagemProdutoComponent>>(`${this.url}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  printForm(controle: number , formId: number, onlyPrint = false): Observable<any> {
    return this.http.get(`${this.url}/print/${controle}/${formId}/${onlyPrint}`, {responseType: 'arraybuffer'});
  }
}
